exports.IDS = {
  IMG_URL: "https://node.falconsfx.in",
  // IMG_URL: "https://falconnode.profcymadev.com:1517",
  // IMG_URL: "http://127.0.0.1:1515",
  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
